import {doGET, shopRestBackendBaseUrl, type Substitute} from 'dummen-shared';
import type {ShoppingCartOrderLine} from 'dummen-shared/src/interfaces/order.line.type.ts';

export const getSubstitutes = async (language: string, region: string, orderLine: ShoppingCartOrderLine): Promise<Substitute[]> => {
	let url = `${shopRestBackendBaseUrl}/app/${language}/substitutes/${region}/${orderLine.articleId}`;

	// Add the week in correct format of year week : YYYYWW
	url = `${url}?week=${orderLine.year}${orderLine.week.toString().padStart(2, '0')}`;

	if (orderLine.formId) {
		url = `${url}&formId=${orderLine.formId}`;
	}

	const response = await doGET(url);
	return response.json();
};
